import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M21,2H11a9,9,0,0,0-9,9V21a9,9,0,0,0,9,9H21a9,9,0,0,0,9-9V11A9,9,0,0,0,21,2Zm7,19a7,7,0,0,1-7,7H11a7,7,0,0,1-7-7V11a7,7,0,0,1,7-7H21a7,7,0,0,1,7,7Z"/><path d="M16,9a7,7,0,1,0,7,7A7,7,0,0,0,16,9Zm0,12a5,5,0,1,1,5-5A5,5,0,0,1,16,21Z"/><circle cx="23.5" cy="8.5" r="1.5"/>';
export var InstagramSVG = function InstagramSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
InstagramSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(InstagramSVG);